'use strict';

var $ = require('jquery');

function emojiremove() {
    // Tnge of emojis.
    // Complete list: http://unicode.org/emoji/charts/full-emoji-list.html
    var ranges = [
        '[\uE000-\uF8FF]',
        '\uD83C[\uDC00-\uDFFF]',
        '\ud83D[\uDC00-\uDFFF]',
        '[\u2580-\u27BF]',
        '\uD83E[\uDD10-\uDDFF]',
        '[\u0008-\u0008]'
    ];

    // replace emojis for blank
    function removeInvalidChars(str) {
        return str.replace(new RegExp(ranges.join('|'), 'g'), '');
    }

    // Geting forms
    $(document).on('submit', 'form', function (e) {
        var form = this;
        var fields = $(form).serializeArray();
        $(fields).each(function () {
            var name = this.name;
            var value = this.value;
            $('input[name=' + name + ']', form).val(removeInvalidChars(value));
        });
    });
}

module.exports = {
    init: function () {
        emojiremove();
    }
};
